import { render } from "./icon-check.svg?vue&type=template&id=129361dc?inline"
const script = {}
script.render = render

export default script